import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './booking-time.reducer';

export const BookingTimeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bookingTimeEntity = useAppSelector(state => state.bookingTime.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bookingTimeDetailsHeading">
          <Translate contentKey="activitiesApp.bookingTime.detail.title">BookingTime</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{bookingTimeEntity.id}</dd>
          <dt>
            <span id="bookedTime">
              <Translate contentKey="activitiesApp.bookingTime.bookedTime">Booked Time</Translate>
            </span>
          </dt>
          <dd>
            {bookingTimeEntity.bookedTime ? <TextFormat value={bookingTimeEntity.bookedTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <Translate contentKey="activitiesApp.bookingTime.activityTimeAvailability">Activity Time Availability</Translate>
          </dt>
          <dd>{bookingTimeEntity.activityTimeAvailability ? bookingTimeEntity.activityTimeAvailability.fromDate : ''}</dd>
          <dt>
            <Translate contentKey="activitiesApp.bookingTime.booking">Booking</Translate>
          </dt>
          <dd>{bookingTimeEntity.booking ? bookingTimeEntity.booking.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/booking-time" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/booking-time/${bookingTimeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BookingTimeDetail;
